import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Observable, startWith, map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Output, EventEmitter, Input } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-stakeholder',
  templateUrl: './stakeholder.component.html',
  styleUrls: ['./stakeholder.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatIconModule, MatChipsModule, MatAutocompleteModule, MatInputModule, MatSelectModule, MatFormFieldModule],
})
export class StakeholderComponent implements OnInit {
  @Input() selectedStakeholders: string[] = [];

  stakeholderControl = new FormControl('');
  stakeholders: string[] = [
    'Architect',
    'Structure Designer',
    'Constructor',
    'Land Surveyor',
    'Consultant',
    'Quantity Surveyor',
    'MEP Engineer',
  ];
  filteredStakeholders!: Observable<string[]>;
  // selectedStakeholders: string[] = [];

  showDropdown = false;
  @Output() contentChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() removeContent: EventEmitter<string> = new EventEmitter<string>();
  ngOnInit() {
    this.filteredStakeholders = this.stakeholderControl.valueChanges.pipe(
      startWith(''), // Emit initial value
      map((value) => this.filterStakeholders(value || '')) // Map the input value to the filtered stakeholders
    );

    console.log('The selected stakeholder is:', this.selectedStakeholders);
  }

  private filterStakeholders(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.stakeholders.filter((stakeholder) =>
      stakeholder.toLowerCase().includes(filterValue)
    );
  }

  onSelectionChange(option: string) {
    if (!this.selectedStakeholders.includes(option)) {
      this.contentChange.emit(option);
    }
    this.stakeholderControl.setValue(''); // Reset the input after selection
    this.showDropdown = false; // Hide dropdown after selection
  }
  addStakeholder(option: string) {
    if (!this.selectedStakeholders.includes(option)) {
      this.contentChange.emit(option);
    }
    this.stakeholderControl.setValue('');
    this.showDropdown = false;
  }

  remove(stakeholder: string): void {
    const index = this.selectedStakeholders.indexOf(stakeholder);
    if (index >= 0) {
      this.selectedStakeholders.splice(index, 1);
    }
    console.log(stakeholder);
    this.removeContent.emit(stakeholder);
  }

  onFocus() {
    this.showDropdown = true; // Show the dropdown when input is focused
  }

  onBlur() {
    // Hide the dropdown when input is blurred (optional)
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.stopPropagation(); // Prevent Mat-Select from handling Space
    }
  }
  
}
